export function JobCardSkeleton() {
  return (
    <div className="border border-gray-200 shadow-sm bg-white rounded-lg">
      <div className="p-6">
        <div className="animate-pulse">
          {/* Job Header with Salary Badge */}
          <div className="flex items-start justify-between mb-6">
            <div className="flex-1">
              <div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>
            <div className="h-6 bg-gray-200 rounded w-16 ml-4"></div>
          </div>
          
          {/* Job Details */}
          <div className="space-y-3 mb-6">
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded w-1/3"></div>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>
          </div>
          
          {/* Footer */}
          <div className="flex items-center justify-between pt-4 border-t border-gray-100">
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded w-20"></div>
            </div>
            <div className="h-8 bg-gray-200 rounded w-24"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

interface JobCardSkeletonGridProps {
  count?: number;
}

export function JobCardSkeletonGrid({ count = 6 }: JobCardSkeletonGridProps) {
  return (
    <>
      {[...Array(count)].map((_, i) => (
        <JobCardSkeleton key={i} />
      ))}
    </>
  );
}
